import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M1.28266 7.77514L2.66728 1.77514C2.77198 1.32141 3.17601 1 3.64167 1H5.79507C6.42121 1 6.89334 1.56888 6.77795 2.18429L5.65295 8.18429C5.56426 8.65726 5.15129 9 4.67007 9H2.25705C1.61397 9 1.13806 8.40176 1.28266 7.77514Z" stroke="#D84935" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M20.7173 7.77514L19.3327 1.77514C19.228 1.32141 18.824 1 18.3583 1H16.2049C15.5788 1 15.1067 1.56888 15.2221 2.18429L16.3471 8.18429C16.4357 8.65726 16.8487 9 17.3299 9H19.7429C20.386 9 20.8619 8.40176 20.7173 7.77514Z" stroke="#D84935" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M5.75348 7.79427L7.01484 1.79427C7.11215 1.33139 7.52045 1 7.99345 1H10C10.5523 1 11 1.44772 11 2V8C11 8.55228 10.5523 9 10 9H6.73209C6.09703 9 5.62283 8.41574 5.75348 7.79427Z" stroke="#D84935" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M16.2465 7.79427L14.9852 1.79427C14.8878 1.33139 14.4795 1 14.0066 1H12C11.4477 1 11 1.44772 11 2V8C11 8.55228 11.4477 9 12 9H15.2679C15.903 9 16.3772 8.41574 16.2465 7.79427Z" stroke="#D84935" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M4 9V16C4 16.5523 4.44772 17 5 17H17C17.5523 17 18 16.5523 18 16V9" stroke="#D84935" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M9 16.5V14C9 13.4477 9.44772 13 10 13H12C12.5523 13 13 13.4477 13 14V16.5" stroke="#D84935" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props) {
    t6 = <Svg width={22} height={18} viewBox="0 0 22 18" fill="none" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}</Svg>;
    $[6] = props;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default Icon;